import axios from "@/api/axiosInstance";
import { RefreshStochasticDashboardDataResponse } from "./types";

export const refreshStochasticDashboardData = async (
  intacctId: string,
): Promise<RefreshStochasticDashboardDataResponse> => {
  const response = await axios.post<RefreshStochasticDashboardDataResponse>(
    `/api/private/stochastic/sc-dashboard/refresh`,
    null,
    { params: { intacctId } },
  );

  return response.data;
};
